import './Real.scss';

import logo from '../../Navbar/Logo_skinny.png';

import Loader from '../../Loader/Loader';

import {NavLink, useParams, useNavigate} from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CottageIcon from '@mui/icons-material/Cottage';


const Real= ({datas, loader}) => {

  const params = useParams();
  let navigate = useNavigate();

  console.log(params)

  return loader ? (
    <Loader />
  )
  :
  (
    <div className='page'>
     
      <h1 className='page-title'>
      <NavLink
        to='/'
      > <img src={logo}  alt='logo skinny' className='logo_pages-banner'/>
     
    </NavLink>
       - Catégorie Réalistes - </h1>
       <div className="img_container ">
      {datas.map((data) => {
        return(
          <NavLink
          to={`/real/zoom/${data.id}`} >
         <img src={data.url} alt='realistes' className='data_item' />
         </NavLink>
        )
      })}
       </div>
      

   

        <NavLink
        to='/'
        className='page-back'
         > <CottageIcon/> 

        </NavLink>

        <button
          onClick={() => navigate(-1)}
          className='page-back--btn'
          >  <ArrowBackIosNewIcon/> 
        </button>

  
    </div>

  )
}

export default Real;